import React from 'react';
import {
  MobileMenuButtonTypes,
  MenuNavigationItemTypeGroup,
  ProfileMenu, MenuNavigationCustomSubMenu
} from '../types';
import styled from 'styled-components';
import Breakpoints from '../../styles/breakpoints';
import {IconButton} from '../../Button';
import {SystemIcons} from '../../icons';
import {BREAKPOINTS, COLORS, ComponentSStyling, ComponentTextStyle, ComponentXSStyling} from '../../styles';
import {ProfileButton} from '../../ProfileButton';

export const MobileMenuHeaderActions = styled.div`
  flex: 1;
  justify-content: flex-end;
  display: flex;
  flex-direction: row;
`;
const MobileMenuHeaderLabel = styled.div`
  ${ComponentXSStyling(ComponentTextStyle.Bold, COLORS.neutral_600)}
  ${BREAKPOINTS.SMALL} {
    ${ComponentSStyling(ComponentTextStyle.Bold, COLORS.neutral_600)}
  }
`;

export const MobileMenuHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 4px;

  ${Breakpoints.SMALL} {
    padding: 4px 8px;
  }

  ${Breakpoints.LARGE} {
    display: none;
  }
`

interface MobileMenuHeaderProps {
  onGoBack?: () => void;
  onClose: () => void;
  label?: string;

  profile?: ProfileMenu
  buttons?: MobileMenuButtonTypes[];

  onSubMenuOpen?: (item?: MenuNavigationItemTypeGroup | MenuNavigationCustomSubMenu) => void;
}


const MobileMenuHeader: React.FunctionComponent<MobileMenuHeaderProps> = ({
                                                                            onGoBack,
                                                                            onClose,
                                                                            label,
                                                                            profile,
                                                                            buttons,
                                                                            onSubMenuOpen
                                                                          }) => {

  const buildProfileSubMenu = () => !!profile ? {
    type: 'group',
    label: profile.label,
    header: {
      header: profile.user.firstName + ' ' + profile.user.lastName,
      note: profile.user.email,
      link: profile.user.link
    },
    action: {
      label: profile.signOut?.label,
      action: profile.signOut?.action,
      icon: profile.signOut?.icon,
      disabled: profile.signOut?.disabled
    },
    items: profile.sections.map(a => ({...a, type: 'section'}))
  } as MenuNavigationItemTypeGroup : undefined

  const renderItem = (item: MobileMenuButtonTypes, index: number) => {
    switch (item.type) {
      case 'profile': {
        const {placement, type, action, ...rest} = item;
        if(!!profile)
          return  <ProfileButton key={index}
                              onClick={e => {
                                e?.nativeEvent.stopImmediatePropagation();
                                item.action ? item.action(e?.target) && onClose() : onSubMenuOpen && onSubMenuOpen(buildProfileSubMenu())
                              }}
                              icon={!profile && <SystemIcons.User/>}
                              initials={(profile?.user?.firstName?.charAt(0) ?? '') + (profile?.user?.lastName?.charAt(0) ?? '')}
                              {...rest}/>
        else return <></>
          
      }
      case 'submenu': {
        const {placement, type, icon, menu, ...rest} = item;

        return <IconButton key={index}
                           variant={'secondary'}
                           shape={'circular'}
                           action={e => {
                             e?.nativeEvent.stopImmediatePropagation();
                             onSubMenuOpen && onSubMenuOpen(item.menu)
                           }}
                           {...rest}>
          {item.icon}
        </IconButton>
      }
      case 'action': {
        const {placement, type, icon, action, ...rest} = item;
        return <IconButton key={index}
                           disabled={item.disabled}
                           variant={'secondary'}
                           shape={'circular'}
                           action={e => {
                             e?.nativeEvent.stopImmediatePropagation();
                             item.action && item.action(e?.target) && onClose();
                           }}
                           {...rest}>
          {item.icon}
        </IconButton>
      }
    }
  }

  return (
    <MobileMenuHeaderWrapper>
      {
        onGoBack &&
        <IconButton action={e => {
          e?.nativeEvent.stopImmediatePropagation();
          onGoBack();
        }}
                    variant={'secondary'}
                    shape={'circular'}>
          <SystemIcons.ArrowLineLeft/>
        </IconButton>
      }
      {
        buttons?.filter(a => a.placement === 'left').map(renderItem)
      }
      {
        label &&
        <MobileMenuHeaderLabel>{label}</MobileMenuHeaderLabel>
      }
      <MobileMenuHeaderActions>
        {
          buttons?.filter(a => a.placement !== 'left').map(renderItem)
        }

        {
          onClose &&
          <div style={{marginLeft: '8px'}}>
            <IconButton variant={'secondary'}
                        action={e => {
                          e?.nativeEvent.stopImmediatePropagation();
                          onClose();
                        }}
                        shape={'circular'}>
              <SystemIcons.Close/>
            </IconButton>
          </div>
        }
      </MobileMenuHeaderActions>

    </MobileMenuHeaderWrapper>
  )
};


export default MobileMenuHeader;
